export enum FilterInputType {
  DYNAMIC_MULTI_SELECT = 'dynamic-multi-select',
  CHECKBOX = 'checkbox',
  AGES = 'ages',
  NEIGHBORHOOD = 'neighborhood',
}

export enum Ages {
  UNDER_18 = -9,
  YOUTH_ONLY = -7,
  ADULT_ONLY = -8,
  SENIOR_ONLY = -12,
}

export enum SortOptions {
  WILDCARD = 'wildcard',
  NEIGHBORHOOD = 'neighborhood',
  AZ = 'az',
}
